/* 123custom theme JS */

/* ==========================================================================
   Live chat dismiss (Shopify Inbox)
   Adds an X next to the Inbox chat bubble; clicking it hides the widget for
   the session (#openLiveChat re-shows it). Cost is kept negligible: only the
   known Inbox host elements are matched (no document-wide walks, no text
   scanning), one body-level childList observer, a short bounded retry after
   load, and one rAF per sync. Keep the data-live-chat-dismiss marker.
   ========================================================================== */
(function () {
  var dismissBtn = document.querySelector('[data-live-chat-dismiss]');
  if (!dismissBtn) return;

  var STORAGE_KEY = '123custom-live-chat-dismissed';
  // Shopify Inbox renders one host element (a custom element with a shadow
  // root, or a fixed iframe on older installs). Match only those.
  var HOST_SELECTOR = [
    'inbox-online-store-chat',
    'shopify-chat',
    'shopify-chat-app',
    'shopify-chat-button',
    '#shopify-chat',
    '#ShopifyChat',
    '#dummy-chat-button-iframe',
    '#shopify-chat-app-iframe',
    '#shopify-chat-button-app-iframe',
    '.shopify-chat-container'
  ].join(', ');
  var RETRY_INTERVAL_MS = 500;
  var RETRY_ATTEMPTS = 10; // ~5 s after load, then stop
  var pendingFrame = null;
  var retryTimer = null;
  var retriesLeft = 0;

  function getDismissed() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return document.documentElement.classList.contains('live-chat-widget-dismissed');
    }
  }

  function setDismissed(dismissed) {
    try {
      if (dismissed) {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } else {
        window.sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      // Session storage can be unavailable in private or restricted browsers.
    }
    document.documentElement.classList.toggle('live-chat-widget-dismissed', dismissed);
    document.body.classList.toggle('live-chat-widget-dismissed', dismissed);
    if (dismissed) {
      hideChatElements();
    } else {
      showChatElements();
    }
    scheduleSync();
  }

  function queryHosts() {
    try {
      return document.querySelectorAll(HOST_SELECTOR);
    } catch (error) {
      return [];
    }
  }

  function forceHideElement(element) {
    if (!element || element === dismissBtn) return;
    element.setAttribute('data-live-chat-force-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
  }

  function hideChatElements() {
    var hosts = queryHosts();
    for (var i = 0; i < hosts.length; i += 1) forceHideElement(hosts[i]);
  }

  function showChatElements() {
    document.querySelectorAll('[data-live-chat-force-hidden="true"]').forEach(function (element) {
      element.removeAttribute('data-live-chat-force-hidden');
      element.style.removeProperty('display');
      element.style.removeProperty('opacity');
      element.style.removeProperty('pointer-events');
      element.style.removeProperty('visibility');
    });
  }

  function isVisibleElement(element) {
    if (!element || element === dismissBtn) return false;
    var rect = element.getBoundingClientRect();
    if (rect.width < 10 || rect.height < 10) return false;
    if (rect.bottom <= 0 || rect.right <= 0) return false;
    if (rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  }

  function findVisibleHost() {
    var hosts = queryHosts();
    for (var i = 0; i < hosts.length; i += 1) {
      if (isVisibleElement(hosts[i])) return hosts[i];
    }
    return null;
  }

  // The X sits next to the chat bubble. Prefer the bubble inside the host's
  // shadow root (one targeted query, no tree walk); fall back to the host box.
  function bubbleRect(host) {
    var target = host;
    if (host.shadowRoot) {
      var inner = null;
      try {
        inner = host.shadowRoot.querySelector('[part~="activator"], button, iframe');
      } catch (error) {
        inner = null;
      }
      if (inner && isVisibleElement(inner)) target = inner;
    }
    return target.getBoundingClientRect();
  }

  function positionDismissButton(rect) {
    if (!rect || rect.width < 10 || rect.height < 10) {
      // Unknown bubble geometry: let the stylesheet's fixed position apply.
      dismissBtn.style.left = '';
      dismissBtn.style.top = '';
      dismissBtn.style.right = '';
      dismissBtn.style.bottom = '';
      return;
    }
    var buttonSize = dismissBtn.offsetWidth || 30;
    var left = Math.min(window.innerWidth - buttonSize - 6, Math.max(6, rect.left - (buttonSize * 0.35)));
    var top = Math.max(6, rect.top - (buttonSize * 0.45));

    dismissBtn.style.left = left + 'px';
    dismissBtn.style.top = top + 'px';
    dismissBtn.style.right = 'auto';
    dismissBtn.style.bottom = 'auto';
  }

  function syncDismissButton() {
    pendingFrame = null;
    var dismissed = getDismissed();
    document.documentElement.classList.toggle('live-chat-widget-dismissed', dismissed);
    document.body.classList.toggle('live-chat-widget-dismissed', dismissed);

    if (dismissed) {
      dismissBtn.hidden = true;
      hideChatElements();
      return;
    }

    var host = findVisibleHost();
    dismissBtn.hidden = !host;
    if (host) positionDismissButton(bubbleRect(host));
  }

  function scheduleSync() {
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(syncDismissButton);
  }

  // Inbox initialises asynchronously after its host is inserted, so poll a few
  // times after load until the bubble is visible, then stop for good.
  function startBoundedRetry() {
    retriesLeft = RETRY_ATTEMPTS;
    if (retryTimer) return;
    retryTimer = window.setInterval(function () {
      retriesLeft -= 1;
      if (findVisibleHost() || retriesLeft <= 0) {
        window.clearInterval(retryTimer);
        retryTimer = null;
      }
      scheduleSync();
    }, RETRY_INTERVAL_MS);
  }

  dismissBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    setDismissed(true);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('#openLiveChat')) return;
    setDismissed(false);
    window.setTimeout(scheduleSync, 400);
    window.setTimeout(scheduleSync, 1200);
  }, true);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      scheduleSync();
      if (queryHosts().length) startBoundedRetry();
    }).observe(document.body, { childList: true });
  }

  function onLoad() {
    scheduleSync();
    startBoundedRetry();
  }
  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }
  window.addEventListener('resize', scheduleSync);
  scheduleSync();
})();

(function () {
  var popup = document.querySelector('[data-email-discount-popup]');
  if (!popup) return;

  var closeButtons = popup.querySelectorAll('[data-email-popup-close]');
  var successMessage = popup.querySelector('[data-email-popup-success]');
  var firstField = popup.querySelector('input[type="email"]');
  var STORAGE_KEY = '123custom-email-popup-dismissed';
  var SUCCESS_KEY = '123custom-email-popup-success';
  var delay = window.innerWidth < 750 ? 14000 : 6500;

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function storageSet(key) {
    try {
      window.localStorage.setItem(key, '1');
    } catch (error) {
      // Ignore browsers that block local storage.
    }
  }

  function openPopup(force) {
    if (storageGet(SUCCESS_KEY)) return;
    if (!force && storageGet(STORAGE_KEY)) return;
    if (!force && document.documentElement.classList.contains('shopify-cookie-banner-open')) {
      window.setTimeout(openPopup, 4000);
      return;
    }
    popup.hidden = false;
    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
      document.documentElement.classList.add('email-popup-open');
      if (firstField && window.innerWidth >= 750) firstField.focus({ preventScroll: true });
    });
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('email-popup-open');
    storageSet(STORAGE_KEY);
    window.setTimeout(function () {
      popup.hidden = true;
    }, 220);
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="#footer-newsletter"], a[href="#email-discount-popup"]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openPopup(true);
  }, true);

  if (successMessage) {
    storageSet(SUCCESS_KEY);
    popup.hidden = false;
    popup.classList.add('is-open');
    document.documentElement.classList.add('email-popup-open');
  } else {
    window.setTimeout(openPopup, delay);
  }
})();

/* ==========================================================================
   Cookie banner state — flags <html> while Shopify's privacy banner is open
   so the chat bubble, its dismiss X and the email popup stay out of its way.
   Targeted selectors only, one body-level childList observer plus a small
   observer on the banner itself, a bounded retry after load, no interval.
   ========================================================================== */
(function () {
  var SELECTOR = '#shopify-pc__banner, [id^="shopify-pc__banner"], .shopify-pc__banner, #shopify-privacy-banner';
  var RETRY_INTERVAL_MS = 500;
  var RETRY_ATTEMPTS = 10; // ~5 s after load, then stop
  var pendingFrame = null;
  var retryTimer = null;
  var retriesLeft = 0;
  var bannerObserver = null;
  var observedBanner = null;

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    if (rect.width < 10 || rect.height < 10) return false;
    if (rect.bottom <= 0 || rect.right <= 0) return false;
    if (rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  }

  function queryBanners() {
    try {
      return document.querySelectorAll(SELECTOR);
    } catch (error) {
      return [];
    }
  }

  function findVisibleBanner() {
    var banners = queryBanners();
    for (var i = 0; i < banners.length; i += 1) {
      if (isVisible(banners[i])) return banners[i];
    }
    return null;
  }

  // Watch the banner element itself (attributes) and its parent (removal) so
  // the class flips back off when the shopper accepts or declines.
  function watchBanner(banner) {
    if (!banner || banner === observedBanner || !window.MutationObserver) return;
    if (bannerObserver) bannerObserver.disconnect();
    observedBanner = banner;
    bannerObserver = new MutationObserver(scheduleSync);
    bannerObserver.observe(banner, { attributes: true, attributeFilter: ['class', 'hidden', 'style', 'aria-hidden'] });
    if (banner.parentNode) bannerObserver.observe(banner.parentNode, { childList: true });
  }

  function syncCookieBannerClass() {
    pendingFrame = null;
    var banners = queryBanners();
    document.documentElement.classList.toggle('shopify-cookie-banner-open', !!findVisibleBanner());
    if (banners.length) watchBanner(banners[0]);
  }

  function scheduleSync() {
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(syncCookieBannerClass);
  }

  function startBoundedRetry() {
    retriesLeft = RETRY_ATTEMPTS;
    if (retryTimer) return;
    retryTimer = window.setInterval(function () {
      retriesLeft -= 1;
      if (queryBanners().length || retriesLeft <= 0) {
        window.clearInterval(retryTimer);
        retryTimer = null;
      }
      scheduleSync();
    }, RETRY_INTERVAL_MS);
  }

  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      scheduleSync();
      if (queryBanners().length) startBoundedRetry();
    }).observe(document.body, { childList: true });
  }

  function onLoad() {
    scheduleSync();
    startBoundedRetry();
  }
  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }
  window.addEventListener('resize', scheduleSync);
  scheduleSync();
})();

(function () {
  const carousel = document.querySelector('[data-hero-carousel] [data-carousel]');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('[data-carousel-slide]');
  const dots = carousel.querySelectorAll('[data-carousel-dot]');
  const prevBtn = carousel.querySelector('[data-carousel-prev]');
  const nextBtn = carousel.querySelector('[data-carousel-next]');
  if (slides.length < 2) return;

  let current = 0;
  let autoTimer = null;
  const AUTO_INTERVAL = 6000;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current]?.classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current]?.classList.add('is-active');
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(next, AUTO_INTERVAL);
  }

  function stopAuto() {
    if (autoTimer) clearInterval(autoTimer);
  }

  // Arrows
  if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAuto(); });

  // Dots
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      goTo(parseInt(dot.dataset.carouselDot, 10));
      startAuto();
    });
  });

  // Touch swipe
  let touchStartX = 0;
  let touchEndX = 0;
  carousel.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
  carousel.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
      startAuto();
    }
  }, { passive: true });

  // Pause on hover
  carousel.addEventListener('mouseenter', stopAuto);
  carousel.addEventListener('mouseleave', startAuto);

  // Pause when tab is hidden
  document.addEventListener('visibilitychange', () => {
    document.hidden ? stopAuto() : startAuto();
  });

  startAuto();
})();

/* Variant selector - updates price and availability */
document.addEventListener('change', (event) => {
  const variantSelect = event.target.closest('[data-variant-select]');
  if (!variantSelect) return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  const productRoot = variantSelect.closest('[data-product-root]');
  const priceCurrent = productRoot?.querySelector('[data-price-current]');
  const priceCompare = productRoot?.querySelector('[data-price-compare]');
  const priceSavings = productRoot?.querySelector('[data-price-savings]');
  const addToCart = productRoot?.querySelector('[data-add-to-cart]');
  const atcText = productRoot?.querySelector('[data-atc-text]');
  const stickyPrice = productRoot?.querySelector('[data-sticky-price]');
  const stickyAtc = productRoot?.querySelector('[data-sticky-atc]');
  const available = selectedOption.dataset.available === 'true';

  if (priceCurrent && selectedOption.dataset.price) {
    priceCurrent.textContent = selectedOption.dataset.price;
  }

  if (stickyPrice && selectedOption.dataset.price) {
    stickyPrice.textContent = selectedOption.dataset.price;
  }

  if (priceCompare) {
    const compareValue = selectedOption.dataset.compare || '';
    priceCompare.textContent = compareValue;
    priceCompare.classList.toggle('hidden', compareValue.length === 0);
    if (priceSavings) {
      const savings = selectedOption.dataset.savings || '';
      priceSavings.textContent = savings ? 'Save ' + savings + '%' : '';
      priceSavings.classList.toggle('hidden', compareValue.length === 0 || savings.length === 0);
    }
  }

  if (addToCart) {
    addToCart.disabled = !available;
  }
  if (atcText) {
    var atcLabel = (addToCart && addToCart.dataset.labelAvailable) || 'Add to cart';
    atcText.textContent = available ? atcLabel : 'Sold out';
  }
  if (stickyAtc) {
    stickyAtc.disabled = !available;
    var stickyLabel = stickyAtc.dataset.labelAvailable || 'Add to cart';
    stickyAtc.textContent = available ? stickyLabel : 'Sold out';
  }
});

/* ==========================================================================
   Product Gallery — Thumbnails, Arrows, Dots, Swipe
   ========================================================================== */
(function () {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('[data-media-slide]');
  const thumbs = gallery.querySelectorAll('[data-thumbnail-btn]');
  const dots = gallery.querySelectorAll('[data-gallery-dot]');
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');
  const mainMedia = gallery.querySelector('[data-main-media]');
  if (slides.length < 1) return;

  let current = 0;

  function isMediaControlTarget(target) {
    return target instanceof Element && Boolean(target.closest('.product__media-player'));
  }

  function updateActiveMediaState() {
    if (!mainMedia) return;
    const mediaType = slides[current]?.dataset.mediaType || 'image';
    mainMedia.classList.toggle('has-active-video', mediaType === 'video' || mediaType === 'external_video');
  }

  function goTo(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    slides[current]?.querySelectorAll('video').forEach((video) => video.pause());
    slides[current]?.classList.remove('is-active');
    thumbs[current]?.classList.remove('is-active');
    dots[current]?.classList.remove('is-active');

    current = index;

    slides[current]?.classList.add('is-active');
    thumbs[current]?.classList.add('is-active');
    dots[current]?.classList.add('is-active');
    updateActiveMediaState();

    // Scroll thumbnail into view
    if (thumbs[current]) {
      thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  // Thumbnail clicks
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      goTo(parseInt(thumb.dataset.thumbnailBtn, 10));
    });
  });

  // Dot clicks
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      goTo(parseInt(dot.dataset.galleryDot, 10));
    });
  });

  // Arrow clicks
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  // Touch swipe on main media
  if (mainMedia) {
    let touchStartX = null;
    let touchEndX = 0;
    mainMedia.addEventListener('touchstart', (e) => {
      touchStartX = isMediaControlTarget(e.target) ? null : e.changedTouches[0].screenX;
    }, { passive: true });
    mainMedia.addEventListener('touchend', (e) => {
      if (touchStartX === null || isMediaControlTarget(e.target)) return;
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      touchStartX = null;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });
  }

  // Keyboard navigation when gallery is focused
  gallery.addEventListener('keydown', (e) => {
    if (isMediaControlTarget(e.target)) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
  });

  updateActiveMediaState();

  // Expose for lightbox
  window.__productGallery = { goTo, getCurrent: () => current, getTotal: () => slides.length };
})();

/* ==========================================================================
   Image Zoom / Lightbox
   ========================================================================== */
(function () {
  const lightbox = document.querySelector('[data-lightbox]');
  if (!lightbox) return;

  const imageContainer = lightbox.querySelector('[data-lightbox-image]');
  const closeBtns = lightbox.querySelectorAll('[data-lightbox-close]');
  const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  const nextBtn = lightbox.querySelector('[data-lightbox-next]');
  const zoomTriggers = document.querySelectorAll('[data-zoom-trigger]');
  const productRoot = document.querySelector('[data-product-root]');
  const slides = productRoot?.querySelectorAll('[data-media-slide]') || [];

  function open(index) {
    const img = slides[index]?.querySelector('[data-zoom-trigger] img');
    if (!img) return false;
    const lightboxImage = document.createElement('img');
    lightboxImage.src = img.currentSrc || img.src;
    lightboxImage.alt = img.alt || '';
    imageContainer.replaceChildren(lightboxImage);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function navigate(direction) {
    if (!window.__productGallery) return;
    const gallery = window.__productGallery;
    let next = gallery.getCurrent();
    for (let attempt = 0; attempt < gallery.getTotal(); attempt += 1) {
      next = (next + direction + gallery.getTotal()) % gallery.getTotal();
      if (slides[next]?.querySelector('[data-zoom-trigger] img')) {
        gallery.goTo(next);
        open(next);
        return;
      }
    }
  }

  // Click on image to open lightbox
  zoomTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const slide = trigger.closest('[data-media-slide]');
      const index = parseInt(slide?.dataset.mediaSlide || '-1', 10);
      if (index >= 0) open(index);
    });
  });

  // Close
  closeBtns.forEach((btn) => btn.addEventListener('click', close));

  // Navigate in lightbox
  if (prevBtn) prevBtn.addEventListener('click', () => navigate(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => navigate(1));

  // Keyboard
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });
})();

/* ==========================================================================
   Quantity Selector (+/-)
   ========================================================================== */
document.addEventListener('click', (event) => {
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');

  if (minus) {
    const input = minus.closest('[data-qty-selector]')?.querySelector('[data-qty-input]');
    if (input) {
      const val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val - 1);
    }
  }

  if (plus) {
    const input = plus.closest('[data-qty-selector]')?.querySelector('[data-qty-input]');
    if (input) {
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    }
  }
});

/* ==========================================================================
   Sticky Add-to-Cart Bar — appears when main CTA scrolls out of view
   ========================================================================== */
(function () {
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (!stickyBar || !addToCartBtn) return;

  const stickyAtc = stickyBar.querySelector('[data-sticky-atc]');
  const stickyPersonalise = stickyBar.querySelector('[data-sticky-personalise]');

  if (stickyAtc) {
    stickyAtc.addEventListener('click', () => {
      addToCartBtn.click();
    });
  }

  if (stickyPersonalise) {
    stickyPersonalise.addEventListener('click', () => {
      // Defined by assets/product-designer.js (deferred, runs after this file).
      if (typeof window.openCustomDesigner === 'function') window.openCustomDesigner();
    });
  }


  var observeTarget = document.getElementById('custom-designer-wrapper') || addToCartBtn;

  function setStickyVisible(visible) {
    stickyBar.classList.toggle('is-visible', visible);
    document.documentElement.classList.toggle('product-sticky-bar-visible', visible);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        setStickyVisible(!entry.isIntersecting);
      });
    },
    { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
  );

  observer.observe(observeTarget);
})();

/* ==========================================================================
   Option Buttons — variant selection via exposed buttons/swatches
   ========================================================================== */
(function () {
  const productRoot = document.querySelector('[data-product-root]');
  if (!productRoot) return;

  const variantSelect = productRoot.querySelector('[data-variant-select]');
  if (!variantSelect) return;

  // Option groups in option order (Colour = 0, Size = 1, ...). The dropdown
  // fallback used for >8 values has no [data-option-index] and is not handled
  // here, exactly as before.
  const optionGroups = Array.from(productRoot.querySelectorAll('[data-option-index]'))
    .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
  if (!optionGroups.length) return;

  // Each sellable variant as its ordered list of option values.
  const variants = Array.from(variantSelect.options).map((option) => {
    const raw = option.dataset.optionValues;
    return {
      option,
      values: (raw === undefined ? option.textContent.split(' / ') : raw.split('||'))
        .map((value) => value.trim()),
    };
  });

  const buttonsIn = (group) => Array.from(group.querySelectorAll('[data-option-value], [data-swatch-value]'));
  const valueOf = (btn) => btn.dataset.optionValue || btn.dataset.swatchValue;

  const currentSelection = () => optionGroups.map((group) => {
    const active = group.querySelector('.is-active');
    return active ? valueOf(active) : null;
  });

  // EXACT per-option comparison. Substring matching would let "Gold" match
  // "Rose Gold", so picking Gold + 1.5cm silently added a Rose Gold disc to the
  // cart. null means "any value" (a group with nothing selected yet).
  const findVariant = (wanted) => variants.find((variant) =>
    wanted.every((value, index) => value === null || variant.values[index] === value)) || null;

  // Line through the values that have no variant next to the other choices —
  // e.g. Gold once the 1.5 cm disc is picked, which we do not sell.
  function markUnavailable(selection) {
    optionGroups.forEach((group, index) => {
      buttonsIn(group).forEach((btn) => {
        const probe = selection.slice();
        probe[index] = valueOf(btn);
        const sellable = !!findVariant(probe);
        btn.classList.toggle('is-unavailable', !sellable);
        btn.setAttribute('aria-disabled', sellable ? 'false' : 'true');
      });
    });
  }

  function selectVariant(entry) {
    if (!entry) return;
    optionGroups.forEach((group, index) => {
      buttonsIn(group).forEach((btn) => {
        btn.classList.toggle('is-active', valueOf(btn) === entry.values[index]);
      });
    });
    if (variantSelect.value !== entry.option.value) {
      variantSelect.value = entry.option.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    markUnavailable(entry.values);
  }

  productRoot.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-option-value], [data-swatch-value]');
    if (!btn) return;
    const group = btn.closest('[data-option-index]');
    const index = optionGroups.indexOf(group);
    if (index < 0) return;

    const wanted = currentSelection();
    wanted[index] = valueOf(btn);

    // Honour the shopper's other choices when we sell that combination.
    // Otherwise move to the first variant carrying the value they just clicked
    // and let the other pickers follow, so a combination we do not sell can
    // never reach the cart and the shopper is never trapped on one option.
    const exact = findVariant(wanted);
    const chosen = exact || variants.find((variant) => variant.values[index] === wanted[index]);
    selectVariant(chosen);
    explainSwitch(exact ? null : chosen, wanted, index);
  });

  // Never switch an option silently: when the picker had to move another
  // choice, say so next to the options (e.g. "Gold is not available in 1.5cm,
  // so Colour is now Silver").
  const noteEl = productRoot.querySelector('[data-variant-note]');
  function optionName(i) {
    return (optionGroups[i] && optionGroups[i].dataset.optionName) || `Option ${i + 1}`;
  }
  function explainSwitch(chosen, wanted, clickedIndex) {
    if (!noteEl) return;
    if (!chosen) { noteEl.hidden = true; noteEl.textContent = ''; return; }
    const moved = [];
    chosen.values.forEach((value, i) => {
      if (i !== clickedIndex && wanted[i] !== null && wanted[i] !== value) {
        moved.push(`${optionName(i)} is now ${value}`);
      }
    });
    if (!moved.length) { noteEl.hidden = true; noteEl.textContent = ''; return; }
    const lost = wanted.map((value, i) => (i !== clickedIndex && value !== null && value !== chosen.values[i]) ? value : null).filter(Boolean);
    noteEl.textContent = `${lost.join(' / ')} is not available in ${wanted[clickedIndex]}, so ${moved.join(' and ')}.`;
    noteEl.hidden = false;
  }

  markUnavailable(currentSelection());
})();

/* Close mobile menu when clicking outside */
document.addEventListener('click', (event) => {
  const openMenus = document.querySelectorAll('.mobile-menu[open]');
  openMenus.forEach((menu) => {
    if (!menu.contains(event.target)) {
      menu.removeAttribute('open');
    }
  });
});

/* ==========================================================================
   Header Search — full-width overlay
   ========================================================================== */
(function () {
  const searchWrapper = document.querySelector('[data-site-search]');
  if (!searchWrapper) return;

  const toggleBtn = searchWrapper.querySelector('[data-search-toggle]');
  const closeBtn = searchWrapper.querySelector('[data-search-close]');
  const overlay = searchWrapper.querySelector('[data-search-overlay]');
  const searchInput = searchWrapper.querySelector('[data-search-input]');

  function openSearch() {
    searchWrapper.classList.add('is-open');
    setTimeout(() => searchInput?.focus(), 80);
  }

  function closeSearch() {
    searchWrapper.classList.remove('is-open');
    if (searchInput) searchInput.value = '';
    const predictive = searchWrapper.querySelector('.predictive-search');
    if (predictive) predictive.classList.remove('is-open');
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (overlay) overlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchWrapper.classList.contains('is-open')) closeSearch();
  });
})();

/* ==========================================================================
   Dropdown Navigation — keyboard accessibility
   ========================================================================== */
(function () {
  const dropdowns = document.querySelectorAll('.site-nav__dropdown-wrap');

  dropdowns.forEach((wrap) => {
    const trigger = wrap.querySelector('.site-nav__link--has-child');
    if (!trigger) return;

    // Toggle on click (for touch / keyboard)
    trigger.addEventListener('click', (e) => {
      // If it has a real URL and dropdown is already showing, navigate
      if (wrap.classList.contains('is-open') && trigger.getAttribute('href') !== '#') {
        return; // allow default navigation
      }
      e.preventDefault();
      const isOpen = wrap.classList.contains('is-open');
      // Close all other dropdowns
      dropdowns.forEach((d) => d.classList.remove('is-open'));
      if (!isOpen) {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on Escape
    wrap.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        wrap.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.site-nav__dropdown-wrap')) {
      dropdowns.forEach((d) => {
        d.classList.remove('is-open');
        const trigger = d.querySelector('.site-nav__link--has-child');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();

/* Smooth scroll for anchor links */
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* Header shadow on scroll */
let lastScroll = 0;
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll > 10) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });
}

/* ==========================================================================
   Saved Designs Drawer + Account Listing
   ========================================================================== */
(function () {
  var drawer = document.querySelector('[data-saved-designs-drawer]');
  var STORAGE_KEY = '123custom-shopify-saved-designs:v2';
  var MAX_ITEMS = 24;

  if (!drawer) return;

  var listEl = drawer.querySelector('[data-saved-designs-list]');
  var closeBtns = drawer.querySelectorAll('[data-saved-designs-close]');
  var savedNudge = document.querySelector('[data-saved-designs-nudge]');
  var savedNudgeTimer = null;
  var lastSavedDesignCount = null;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function readSavedDesigns() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      // Entries without a draftKey can't be reopened, and the Remove button
      // matches on draftKey (an empty key would remove them all) — drop them.
      return Array.isArray(parsed)
        ? parsed.filter(function (d) { return d && d.draftKey; }).slice(0, MAX_ITEMS)
        : [];
    } catch (error) {
      return [];
    }
  }

  function writeSavedDesigns(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (error) {
      return;
    }
    window.dispatchEvent(new CustomEvent('saved-designs:updated'));
  }

  function updateSavedDesignCounts(count) {
    document.querySelectorAll('[data-saved-designs-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
    // The header/mobile entry points hide themselves until there is something
    // to open — an "Saved designs" button that only ever showed an empty panel
    // read as dead UI. See sections/header.liquid.
    document.querySelectorAll('[data-saved-designs-slot]').forEach(function (slot) {
      slot.style.display = count > 0 ? '' : 'none';
    });
  }

  function hideSavedDesignNudge() {
    if (!savedNudge) return;
    savedNudge.hidden = true;
    if (savedNudgeTimer) clearTimeout(savedNudgeTimer);
  }

  function showSavedDesignNudge() {
    if (!savedNudge || drawer.classList.contains('is-open')) return;
    savedNudge.hidden = false;
    if (savedNudgeTimer) clearTimeout(savedNudgeTimer);
    savedNudgeTimer = setTimeout(hideSavedDesignNudge, 7000);
  }

  function formatSavedAt(savedAt) {
    if (!savedAt) return 'Saved recently';
    var parsed = new Date(savedAt);
    if (Number.isNaN(parsed.getTime())) return 'Saved recently';

    return parsed.toLocaleString(undefined, {
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  function renderSavedDesignCards(items, context) {
    if (!items.length) {
      return '<div class="saved-designs-empty">'
        + '<svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4.5h12A1.5 1.5 0 0 1 19.5 6v13.5l-7.5-4-7.5 4V6A1.5 1.5 0 0 1 6 4.5Z"/></svg>'
        + '<p>No saved designs yet.</p>'
        + '<span>Start personalising a product and it will appear here.</span>'
        + '</div>';
    }

    return items.map(function (item) {
      var suiteParam = item.suiteKey ? '&suite_key=' + encodeURIComponent(item.suiteKey) : '';
      // A stored reopenUrl on another origin is dead: its IndexedDB draft is
      // not reachable from here, and following it would take the shopper off
      // 123custom.co.uk. Fall through to the rebuilt same-origin product URL.
      var storedReopen = item.reopenUrl || '';
      if (storedReopen.indexOf('http') === 0 && storedReopen.indexOf(window.location.origin + '/') !== 0) {
        storedReopen = '';
      }
      var reopenUrl = storedReopen || (item.productUrl ? item.productUrl + '?variant=' + encodeURIComponent(item.variantId || '') + '&customize=1&draft_key=' + encodeURIComponent(item.draftKey || '') + suiteParam : '#');
      var backgroundSwatch = item.backgroundColor && item.backgroundColor !== 'transparent'
        ? '<span class="saved-design-card__swatch" style="background:' + escapeHtml(item.backgroundColor) + '"></span>'
        : '<span class="saved-design-card__swatch saved-design-card__swatch--empty"></span>';
      var statusBits = [];
      if (item.hasPhoto) statusBits.push('Photo');
      if (item.hasText) statusBits.push('Text');
      if (item.backgroundColor && item.backgroundColor !== 'transparent') statusBits.push('Background');

      return '<article class="saved-design-card saved-design-card--' + context + '">'
        + '<div class="saved-design-card__meta">'
        + '<div>'
        + '<p class="saved-design-card__title">' + escapeHtml(item.productTitle || 'Saved product design') + '</p>'
        + '<p class="saved-design-card__time">' + escapeHtml(formatSavedAt(item.savedAt)) + '</p>'
        + '</div>'
        + backgroundSwatch
        + '</div>'
        + '<p class="saved-design-card__status">' + escapeHtml(statusBits.join(' • ') || 'Draft saved') + '</p>'
        + '<div class="saved-design-card__actions">'
        + '<a class="saved-design-card__action saved-design-card__action--primary" href="' + escapeHtml(reopenUrl) + '">Resume design</a>'
        + '<button class="saved-design-card__action" type="button" data-saved-design-remove="' + escapeHtml(item.draftKey || '') + '">Remove</button>'
        + '</div>'
        + '</article>';
    }).join('');
  }

  function renderSavedDesigns() {
    var items = readSavedDesigns().sort(function (a, b) {
      return new Date(b.savedAt || 0).getTime() - new Date(a.savedAt || 0).getTime();
    });
    var previousCount = lastSavedDesignCount;

    updateSavedDesignCounts(items.length);

    if (listEl) {
      listEl.innerHTML = renderSavedDesignCards(items, 'drawer');
    }

    document.querySelectorAll('[data-saved-designs-page-list]').forEach(function (container) {
      container.innerHTML = renderSavedDesignCards(items, 'page');
    });

    if (previousCount === 0 && items.length > 0) {
      showSavedDesignNudge();
    }
    lastSavedDesignCount = items.length;
  }

  function open() {
    hideSavedDesignNudge();
    renderSavedDesigns();
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
      menu.removeAttribute('open');
    });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.querySelectorAll('[data-saved-designs-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      open();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  drawer.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-saved-design-remove]');
    if (!removeBtn) return;

    var draftKey = removeBtn.getAttribute('data-saved-design-remove');
    var nextItems = readSavedDesigns().filter(function (item) {
      return item && item.draftKey !== draftKey;
    });
    writeSavedDesigns(nextItems);
    renderSavedDesigns();
  });

  window.addEventListener('saved-designs:updated', renderSavedDesigns);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      renderSavedDesigns();
    }
  });

  renderSavedDesigns();
  window.savedDesignsDrawer = { open: open, close: close, refresh: renderSavedDesigns };
})();

/* ==========================================================================
   Direct Cart Designer Return — single-item designs can finalize on /cart
   ========================================================================== */
(function () {
  if (window.__customDesignerCartReturn) return;
  window.__customDesignerCartReturn = true;

  var path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path !== '/cart') return;

  var pageUrl = new URL(window.location.href);
  var params = pageUrl.searchParams;
  if (params.get('cd_return') !== '1') return;

  function route(pathname) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + pathname.replace(/^\//, '');
  }

  function cleanReturnUrl() {
    [
      'cd_return', 'cd_ctx_variant', 'cd_ctx_draft_key', 'cd_ctx_suite',
      'cd_ctx_model', 'cd_ctx_print_width', 'cd_ctx_print_height',
      'cd_ctx_print_unit', 'cd_preview_url', 'cd_production_url',
      'cd_design_id', 'cd_draft_key', 'cd_text', 'cd_photos',
      'cd_admin_order_id', 'cd_props', 'cd_variant_id'
    ].forEach(function (key) { params.delete(key); });
    var nextSearch = params.toString();
    window.history.replaceState({}, '', pageUrl.pathname + (nextSearch ? '?' + nextSearch : '') + pageUrl.hash);
  }

  function normalizeProperties(properties) {
    var normalized = {};
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value !== null && value !== undefined && value !== '') normalized[key] = String(value);
    });
    return normalized;
  }

  function showOverlay(text) {
    var style = document.createElement('style');
    style.textContent =
      '.cd-return-overlay{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.94);}'
      + '.cd-return-overlay__card{text-align:center;font-family:inherit;color:#222;}'
      + '.cd-return-overlay__spinner{width:38px;height:38px;margin:0 auto 14px;border:3px solid #d4dbe5;border-top-color:#1f70ff;border-radius:50%;animation:cd-spin 0.8s linear infinite;}'
      + '.cd-return-overlay__text{font-size:1rem;font-weight:600;margin:0;}'
      + '@keyframes cd-spin{to{transform:rotate(360deg);}}';
    document.head.appendChild(style);
    var overlay = document.createElement('div');
    overlay.className = 'cd-return-overlay';
    overlay.innerHTML = '<div class="cd-return-overlay__card"><div class="cd-return-overlay__spinner"></div><p class="cd-return-overlay__text"></p></div>';
    overlay.querySelector('.cd-return-overlay__text').textContent = text || 'Adding your design to your cart...';
    document.body.appendChild(overlay);
  }

  // Engraved products let the shopper choose the finish inside the designer,
  // and a finish IS a variant — cd_variant_id wins over the launch variant.
  var variantId = params.get('cd_variant_id') || params.get('cd_ctx_variant') || '';
  var productionUrl = params.get('cd_production_url') || '';
  var previewUrl = params.get('cd_preview_url') || '';
  if (!variantId || (!productionUrl && !previewUrl)) {
    cleanReturnUrl();
    return;
  }

  var properties = {
    _design_id: params.get('cd_design_id') || '',
    _draft_key: params.get('cd_ctx_draft_key') || params.get('cd_draft_key') || '',
    _preview_url: previewUrl,
    _production_url: productionUrl,
    _admin_order_id: params.get('cd_admin_order_id') || '',
    _customization_suite: params.get('cd_ctx_suite') || '',
    _customization_model: params.get('cd_ctx_model') || '',
    _print_area_width: params.get('cd_ctx_print_width') || '',
    _print_area_height: params.get('cd_ctx_print_height') || '',
    _print_area_unit: params.get('cd_ctx_print_unit') || '',
    'Custom text': params.get('cd_text') || '',
    Photos: params.get('cd_photos') && params.get('cd_photos') !== '0' ? params.get('cd_photos') : ''
  };

  // Engraving properties (Finish, each engraving line, charm names, image type)
  // travel as one JSON blob so the designer can add fields without a theme push.
  try {
    var rawEngravingProps = params.get('cd_props');
    if (rawEngravingProps) {
      var engravingProps = JSON.parse(rawEngravingProps);
      if (engravingProps && typeof engravingProps === 'object') {
        Object.keys(engravingProps).forEach(function (key) {
          if (engravingProps[key]) properties[key] = String(engravingProps[key]);
        });
      }
    }
  } catch (error) {
    // Malformed props must never block the cart add — the artwork still lands.
  }

  cleanReturnUrl();
  showOverlay('Adding your design to your cart...');

  fetch(route('/cart/add.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: normalizeProperties(properties)
    })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add item to cart.');
        });
      }
      window.location.replace(route('/cart'));
    })
    .catch(function (error) {
      alert('Could not add your design to the cart: ' + (error && error.message ? error.message : 'Please try again.'));
      window.location.replace(route('/cart'));
    });
})();

/* ==========================================================================
   AJAX Cart Drawer
   ========================================================================== */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var closeBtns = drawer.querySelectorAll('[data-cart-drawer-close]');
  var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  var body = drawer.querySelector('[data-cart-drawer-body]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
  var totalEl = drawer.querySelector('[data-cart-drawer-total]');
  var countEl = drawer.querySelector('[data-cart-drawer-count]');
  var shippingEl = drawer.querySelector('[data-cart-drawer-shipping]');

  var moneyFormat = window.shopMoneyFormat || '\u00a3{{amount}}';
  var freeShippingThreshold = window.cartFreeShippingThreshold || 0;
  // Seeded from Liquid so the checkout warning is accurate before the first
  // AJAX render (renderCart recomputes it from live cart data after that).
  var pendingDesignCount = parseInt(drawer.getAttribute('data-cart-drawer-pending'), 10) || 0;
  var pendingEngravingCount = parseInt(drawer.getAttribute('data-cart-drawer-engraving-pending'), 10) || 0;

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountNoDec = Math.round(cents / 100).toString();
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDec)
      .replace('{{amount_no_decimals}}', amountNoDec)
      .replace('{{amount}}', amount);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
    if (match) return match[1] + '_' + size + '.' + match[2] + (match[3] || '');
    return url;
  }

  function getItemProperty(properties, key) {
    if (!properties || typeof properties !== 'object') return '';
    var value = properties[key];
    return typeof value === 'string' ? value : '';
  }

  function buildDesignReopenUrl(item) {
    var baseUrl = item.url || '';
    if (!baseUrl) return '';
    var draftKey = getItemProperty(item.properties, '_draft_key');
    var suiteKey = getItemProperty(item.properties, '_customization_suite');
    // Match the Liquid cart: a draft key OR a suite key is enough to reopen
    // the designer (pending lines added by the iframe may lack _draft_key).
    if (!draftKey && !suiteKey) return '';

    try {
      var url = new URL(baseUrl, window.location.origin);
      if (item.variant_id) {
        url.searchParams.set('variant', String(item.variant_id));
      }
      url.searchParams.set('customize', '1');
      if (draftKey) url.searchParams.set('draft_key', draftKey);
      if (item.key) {
        // line_key lets the designer update this exact cart line in place
        // (via /cart/change.js) instead of adding a duplicate line.
        url.searchParams.set('line_key', item.key);
      }
      if (suiteKey) {
        url.searchParams.set('suite_key', suiteKey);
      }

      return url.pathname + url.search + url.hash;
    } catch (error) {
      return baseUrl;
    }
  }

  function getPackSize(item) {
    var raw = getItemProperty(item.properties, '_pack_size');
    if (!raw) return 0;
    var n = parseInt(raw, 10);
    return isNaN(n) ? 0 : n;
  }

  // True when a personalisable line still needs artwork (added "design later",
  // or a pack with empty slots). Used to warn before checkout.
  function itemNeedsDesign(item) {
    var packSize = getPackSize(item);
    if (packSize > 1) {
      var filled = 0;
      for (var i = 1; i <= packSize; i++) {
        if (getItemProperty(item.properties, '_design_' + i + '_preview_url')
          || getItemProperty(item.properties, '_design_' + i + '_production_url')) filled++;
      }
      return filled < packSize;
    }
    if (getItemProperty(item.properties, '_preview_url') || getItemProperty(item.properties, '_production_url')) {
      return false;
    }
    return getItemProperty(item.properties, '_design_status') === 'pending'
      || !!getItemProperty(item.properties, '_customization_suite');
  }

  function renderPackSummary(item, classPrefix) {
    var packSize = getPackSize(item);
    if (packSize < 2) return '';

    var baseUrl = item.url || '';
    var variantId = item.variant_id ? String(item.variant_id) : '';
    var suiteKey = getItemProperty(item.properties, '_customization_suite');
    var lineKey = item.key || '';

    var filled = 0;
    for (var f = 1; f <= packSize; f++) {
      if (getItemProperty(item.properties, '_design_' + f + '_preview_url')
        || getItemProperty(item.properties, '_design_' + f + '_production_url')) filled++;
    }
    var complete = filled >= packSize;
    var isBundleLine = suiteKey.indexOf('bundle') > -1;
    var packWord = isBundleLine ? 'Bundle' : ('Pack of ' + packSize);

    var html = '<div class="' + classPrefix + ' ' + classPrefix + '--pack' + (complete ? '' : ' ' + classPrefix + '--pending') + '">';
    if (complete) {
      html += '<p class="' + classPrefix + '-label"><span class="' + classPrefix + '-label-check">✓</span> ' + packWord + ' — designs ready</p>';
    } else {
      html += '<p class="' + classPrefix + '-label ' + classPrefix + '-label--pending">' + packWord + ' — ' + filled + ' of ' + packSize + ' designed · tap an item to add its design</p>';
    }
    html += '<div class="' + classPrefix + '-pack-thumbs">';
    for (var i = 1; i <= packSize; i++) {
      var slotPreview = getItemProperty(item.properties, '_design_' + i + '_preview_url');
      var slotProduction = getItemProperty(item.properties, '_design_' + i + '_production_url');
      var slotDraft = getItemProperty(item.properties, '_design_' + i + '_draft_key');
      var thumb = slotProduction || slotPreview;

      var editUrl = '';
      if (baseUrl) {
        try {
          var u = new URL(baseUrl, window.location.origin);
          if (variantId) u.searchParams.set('variant', variantId);
          u.searchParams.set('customize', '1');
          if (slotDraft) u.searchParams.set('draft_key', slotDraft);
          u.searchParams.set('pack_slot', String(i));
          if (lineKey) u.searchParams.set('line_key', lineKey);
          if (suiteKey) u.searchParams.set('suite_key', suiteKey);
          editUrl = u.pathname + u.search + u.hash;
        } catch (e) {
          editUrl = '';
        }
      }

      var slotLabel = getItemProperty(item.properties, '_design_' + i + '_label') || ('Item ' + i);
      html += '<a class="' + classPrefix + '-pack-thumb" href="' + escapeHtml(editUrl) + '" aria-label="Edit design ' + i + ' of ' + packSize + '">';
      if (thumb) {
        html += '<img src="' + escapeHtml(thumb) + '" alt="Design ' + i + '" loading="lazy">';
      } else {
        html += '<span class="' + classPrefix + '-pack-thumb-empty">' + i + '</span>';
      }
      html += '<span class="' + classPrefix + '-pack-thumb-label">' + escapeHtml(slotLabel) + '</span>';
      html += '</a>';
    }
    html += '</div></div>';
    return html;
  }

  // Engraved lines carry their wording as plain line item properties (no
  // designer artwork), so the drawer lists them instead of showing a preview.
  function buildEngravingEditUrl(item) {
    var baseUrl = item.url || '';
    if (!baseUrl) return '';
    try {
      var url = new URL(baseUrl, window.location.origin);
      if (item.variant_id) url.searchParams.set('variant', String(item.variant_id));
      if (item.key) url.searchParams.set('line_key', item.key);
      return url.pathname + url.search + '#engraving-panel';
    } catch (error) {
      return baseUrl;
    }
  }

  function itemNeedsEngraving(item) {
    return getItemProperty(item.properties, '_engraving_status') === 'pending';
  }

  function renderEngravingSummary(item, classPrefix) {
    if (!getItemProperty(item.properties, '_engraving_kind')) return '';
    var editUrl = buildEngravingEditUrl(item);

    if (itemNeedsEngraving(item)) {
      var pending = '<div class="' + classPrefix + ' ' + classPrefix + '--pending">';
      pending += '<div class="' + classPrefix + '-content">';
      pending += '<p class="' + classPrefix + '-label ' + classPrefix + '-label--pending">⚠ Engraving needed</p>';
      pending += '<div class="' + classPrefix + '-actions">';
      if (editUrl) {
        pending += '<a class="' + classPrefix + '-action ' + classPrefix + '-action--primary" href="' + escapeHtml(editUrl) + '">Add your engraving</a>';
      }
      pending += '</div>';
      pending += '<p class="' + classPrefix + '-note">We can’t engrave this until you tell us the wording.</p>';
      pending += '</div></div>';
      return pending;
    }

    var rows = '';
    if (item.properties && typeof item.properties === 'object') {
      Object.keys(item.properties).forEach(function (name) {
        if (!name || name.charAt(0) === '_') return;
        var value = item.properties[name];
        if (value == null || value === '') return;
        var text = String(value);
        var rendered = /^https?:\/\//.test(text)
          ? '<a href="' + escapeHtml(text) + '" target="_blank" rel="noopener">View uploaded image</a>'
          : escapeHtml(text);
        rows += '<div class="cart-drawer__engraving-row"><dt>' + escapeHtml(name) + '</dt><dd>' + rendered + '</dd></div>';
      });
    }
    if (!rows) return '';

    var html = '<div class="' + classPrefix + ' ' + classPrefix + '--engraving">';
    html += '<div class="' + classPrefix + '-content">';
    html += '<p class="' + classPrefix + '-label">Your engraving</p>';
    html += '<dl class="cart-drawer__engraving-list">' + rows + '</dl>';
    html += '<div class="' + classPrefix + '-actions">';
    if (editUrl) {
      html += '<a class="' + classPrefix + '-action ' + classPrefix + '-action--primary" href="' + escapeHtml(editUrl) + '">Edit engraving</a>';
    }
    html += '</div></div></div>';
    return html;
  }

  function renderDesignSummary(item, classPrefix) {
    var previewUrl = getItemProperty(item.properties, '_preview_url');
    var productionUrl = getItemProperty(item.properties, '_production_url');
    var suiteKey = getItemProperty(item.properties, '_customization_suite');
    var designStatus = getItemProperty(item.properties, '_design_status');
    var reopenUrl = buildDesignReopenUrl(item);
    var hasDesign = previewUrl || productionUrl;

    // Personalisable item that was added to cart without a design yet → prompt to add one.
    if (!hasDesign) {
      var isPending = designStatus === 'pending' || !!suiteKey;
      if (!isPending) return '';
      var pendingHtml = '<div class="' + classPrefix + ' ' + classPrefix + '--pending">';
      pendingHtml += '<div class="' + classPrefix + '-content">';
      pendingHtml += '<p class="' + classPrefix + '-label ' + classPrefix + '-label--pending">⚠ Design needed</p>';
      pendingHtml += '<div class="' + classPrefix + '-actions">';
      if (reopenUrl) {
        pendingHtml += '<a class="' + classPrefix + '-action ' + classPrefix + '-action--primary" href="' + escapeHtml(reopenUrl) + '">Add your design</a>';
      }
      pendingHtml += '</div>';
      pendingHtml += '<p class="' + classPrefix + '-note">We can’t print this until a design is added.</p>';
      pendingHtml += '</div></div>';
      return pendingHtml;
    }

    // Collect visible (non-underscore) properties for the in-theme preview modal
    var detailsHtml = '';
    if (item.properties && typeof item.properties === 'object') {
      Object.keys(item.properties).forEach(function (name) {
        if (!name || name.charAt(0) === '_') return;
        var value = item.properties[name];
        if (value == null || value === '') return;
        var safeValue = escapeHtml(String(value)).replace(/\n/g, '<br>');
        detailsHtml += '<div class="cart-design-modal__detail">'
          + '<span class="cart-design-modal__detail-label">' + escapeHtml(name) + '</span>'
          + '<span class="cart-design-modal__detail-value">' + safeValue + '</span>'
          + '</div>';
      });
    }

    var sharedAttrs = ' data-design-preview-link'
      + ' data-preview="' + escapeHtml(previewUrl || '') + '"'
      + ' data-production="' + escapeHtml(productionUrl || '') + '"'
      + ' data-reopen="' + escapeHtml(reopenUrl || '') + '"'
      + ' data-title="' + escapeHtml(item.product_title || item.title || '') + '"'
      + ' data-variant="' + escapeHtml(item.variant_title || '') + '"'
      + ' data-suite="' + escapeHtml(suiteKey || '') + '"'
      + ' data-details-html="' + escapeHtml(detailsHtml) + '"';

    var html = '<div class="' + classPrefix + '">';
    if (previewUrl) {
      html += '<a class="' + classPrefix + '-preview" href="#" role="button"' + sharedAttrs + ' aria-label="Preview your saved design">';
      html += '<img src="' + escapeHtml(previewUrl) + '" alt="Saved design preview" loading="lazy">';
      html += '</a>';
    }
    html += '<div class="' + classPrefix + '-content">';
    html += '<p class="' + classPrefix + '-label">Your design</p>';
    html += '<div class="' + classPrefix + '-actions">';
    if (previewUrl) {
      html += '<a class="' + classPrefix + '-action" href="#" role="button"' + sharedAttrs + '>Preview</a>';
    }
    if (reopenUrl) {
      html += '<a class="' + classPrefix + '-action ' + classPrefix + '-action--primary" href="' + escapeHtml(reopenUrl) + '">Edit design</a>';
    }
    html += '</div>';
    if (productionUrl) {
      html += '<p class="' + classPrefix + '-note">Print-ready artwork is already saved with this item.</p>';
    }
    html += '</div></div>';
    return html;
  }

  /* ---------- Open / Close ---------- */

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ---------- Fetch & Render ---------- */

  function route(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path.replace(/^\//, '');
  }

  function fetchCart() {
    fetch(route('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (e) { console.error('Cart fetch error:', e); });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      body.style.display = 'none';
      footer.style.display = 'none';
      emptyState.style.display = '';
      shippingEl.innerHTML = '';
      return;
    }

    body.style.display = '';
    footer.style.display = '';
    emptyState.style.display = 'none';

    shippingEl.innerHTML =
      '<div class="shipping-bar shipping-bar--achieved"><p class="shipping-bar__text">Most orders dispatch next business day. Bulk embroidered stockings: allow 10–14 days.</p>' +
      '<div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:100%"></div></div></div>';

    // Items
    var html = '';
    pendingDesignCount = 0;
    pendingEngravingCount = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (itemNeedsEngraving(item)) pendingEngravingCount++;
      else if (itemNeedsDesign(item)) pendingDesignCount++;
      html += '<div class="cart-drawer__item" data-cart-drawer-item="' + item.key + '">';
      html += '<a class="cart-drawer__item-image" href="' + item.url + '">';
      if (item.image) {
        html += '<img src="' + getSizedImageUrl(item.image, '120x') + '" alt="' + escapeHtml(item.title) + '" loading="lazy">';
      }
      html += '</a>';
      html += '<div class="cart-drawer__item-details">';
      html += '<a class="cart-drawer__item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>';
      if (item.variant_title) {
        html += '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
      }
      html += '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      if (getPackSize(item) > 1) {
        html += renderPackSummary(item, 'cart-drawer__design');
      } else if (getItemProperty(item.properties, '_engraving_kind')) {
        html += renderEngravingSummary(item, 'cart-drawer__design');
      } else {
        html += renderDesignSummary(item, 'cart-drawer__design');
      }
      html += '<div class="cart-drawer__item-actions">';
      html += '<div class="cart-drawer__qty" data-cart-drawer-qty>';
      html += '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-change="' + item.key + '" data-direction="minus" aria-label="Decrease quantity">&minus;</button>';
      html += '<span class="cart-drawer__qty-value">' + item.quantity + '</span>';
      html += '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-change="' + item.key + '" data-direction="plus" aria-label="Increase quantity">&plus;</button>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer__remove" data-cart-remove="' + item.key + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">Remove</button>';
      html += '</div></div></div>';
    }
    if (pendingEngravingCount > 0) {
      var engNoun = pendingEngravingCount === 1 ? 'item still needs engraving text' : 'items still need engraving text';
      html = '<div class="cart-drawer__pending-note">⚠ ' + pendingEngravingCount + ' ' + engNoun
        + '. Add ' + (pendingEngravingCount === 1 ? 'it' : 'them') + ' below, or we’ll email you after checkout.</div>' + html;
    }
    if (pendingDesignCount > 0) {
      var pendNoun = pendingDesignCount === 1 ? 'item still needs a design' : 'items still need a design';
      html = '<div class="cart-drawer__pending-note">⚠ ' + pendingDesignCount + ' ' + pendNoun
        + '. Add ' + (pendingDesignCount === 1 ? 'it' : 'them') + ' below, or we’ll email you after checkout.</div>' + html;
    }
    itemsContainer.innerHTML = html;

    var firstItem = itemsContainer.querySelector('.cart-drawer__item');
    if (firstItem) firstItem.classList.add('is-new');

    // Total
    totalEl.textContent = formatMoney(cart.total_price);
  }

  function updateCount(count) {
    if (countEl) countEl.textContent = '(' + count + ')';
    // Update header badge(s)
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---------- Update / Remove items ---------- */

  // Ignore stepper clicks while a change is in flight: two fast clicks would
  // both read the same displayed quantity and net a single +1.
  var cartChangeInFlight = false;

  function updateItem(key, quantity) {
    if (cartChangeInFlight) return;
    cartChangeInFlight = true;
    fetch(route('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && (data.description || data.message) || 'Could not update cart.');
          return data;
        });
      })
      .then(function (cart) {
        cartChangeInFlight = false;
        renderCart(cart);
      })
      .catch(function (e) {
        cartChangeInFlight = false;
        console.error('Cart update error:', e);
        if (window.showToast) window.showToast(e && e.message ? e.message : 'Could not update cart. Please try again.', { type: 'error' });
        fetchCart();
      });
  }

  // Event delegation for qty +/- and remove
  drawer.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('[data-cart-drawer-checkout]');
    if (checkoutLink && pendingDesignCount > 0) {
      var proceed = window.confirm(
        (pendingDesignCount === 1
          ? 'One item still needs a design.'
          : pendingDesignCount + ' items still need a design.')
        + ' Continue to checkout anyway? We’ll email you to collect the artwork.'
      );
      if (!proceed) { e.preventDefault(); return; }
    }
    if (checkoutLink && pendingEngravingCount > 0) {
      var proceedEngraving = window.confirm(
        (pendingEngravingCount === 1
          ? 'One item still needs engraving text.'
          : pendingEngravingCount + ' items still need engraving text.')
        + ' Continue to checkout anyway? We’ll email you to collect the wording.'
      );
      if (!proceedEngraving) { e.preventDefault(); return; }
    }

    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (qtyBtn) {
      var key = qtyBtn.dataset.cartQtyChange;
      var dir = qtyBtn.dataset.direction;
      var qtyEl = qtyBtn.closest('[data-cart-drawer-qty]').querySelector('.cart-drawer__qty-value');
      var qty = parseInt(qtyEl.textContent, 10);
      updateItem(key, dir === 'plus' ? qty + 1 : Math.max(0, qty - 1));
    }

    if (removeBtn) {
      updateItem(removeBtn.dataset.cartRemove, 0);
    }
  });

  /* ---------- Intercept Add-to-Cart forms ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"], [data-add-to-cart]');
    var atcText = submitBtn ? submitBtn.querySelector('[data-atc-text]') : null;
    var originalText = atcText ? atcText.textContent.trim() : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    // Optional fields (e.g. the embroidery names box) must not post a blank
    // line item property, so drop empty [data-omit-if-empty] controls from the
    // payload. FormData skips disabled controls; re-enable them straight after.
    var omitted = Array.prototype.filter.call(form.querySelectorAll('[data-omit-if-empty]'), function (field) {
      return !field.disabled && String(field.value || '').trim() === '';
    });
    omitted.forEach(function (field) { field.disabled = true; });
    var formData = new FormData(form);
    omitted.forEach(function (field) { field.disabled = false; });

    var addSuccess = false;

    fetch(route('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (res.ok) {
          addSuccess = true;
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-success');
            if (atcText) atcText.textContent = '\u2713 Added!';
          }
          setTimeout(function () {
            open();
            var panel = drawer ? drawer.querySelector('.cart-drawer__panel') : null;
            if (panel) {
              panel.classList.add('item-added');
              panel.addEventListener('animationend', function handler() {
                panel.classList.remove('item-added');
                panel.removeEventListener('animationend', handler);
              });
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-loading', 'is-success');
              if (atcText) atcText.textContent = originalText;
            }
          }, 900);
        } else {
          return res.json().then(function (err) {
            var msg = err.description || 'Could not add item to cart.';
            if (window.showToast) window.showToast(msg, { type: 'error' });
            else alert(msg);
          });
        }
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (window.showToast) window.showToast('Something went wrong. Please try again.', { type: 'error' });
      })
      .finally(function () {
        if (!addSuccess && submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading', 'is-success');
          if (atcText) atcText.textContent = originalText;
        }
      });
  });

  /* ---------- Cart toggle button ---------- */

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  /* ---------- Public API ---------- */
  window.cartDrawer = { open: open, close: close, refresh: fetchCart, formatMoney: formatMoney };
})();

/* ==========================================================================
   Toast Notifications
   ========================================================================== */
(function () {
  var container = null;

  function getContainer() {
    if (!container) {
      container = document.createElement('div');
      container.className = 'toast-container';
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'true');
      document.body.appendChild(container);
    }
    return container;
  }

  /**
   * Show a toast notification
   * @param {string} message - text to display
   * @param {Object} [opts] - options
   * @param {string} [opts.type='info'] - 'success' | 'error' | 'info'
   * @param {number} [opts.duration=3500] - ms before auto-dismiss
   */
  function showToast(message, opts) {
    opts = opts || {};
    var type = opts.type || 'info';
    var duration = opts.duration || 3500;

    var toast = document.createElement('div');
    toast.className = 'toast toast--' + type;
    toast.setAttribute('role', 'status');

    var icons = {
      success: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-linecap="round"/><path d="M22 4 12 14.01l-3-3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      error: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15" stroke-linecap="round"/><line x1="9" y1="9" x2="15" y2="15" stroke-linecap="round"/></svg>',
      info: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    toast.innerHTML = '<span class="toast__icon">' + (icons[type] || icons.info) + '</span>'
      + '<span class="toast__message">' + message + '</span>'
      + '<button class="toast__close" aria-label="Dismiss">&times;</button>';

    toast.querySelector('.toast__close').addEventListener('click', function () { dismiss(toast); });

    getContainer().appendChild(toast);

    /* Trigger reflow then animate in */
    toast.offsetHeight; // eslint-disable-line
    toast.classList.add('toast--visible');

    var timer = setTimeout(function () { dismiss(toast); }, duration);
    toast._timer = timer;
  }

  function dismiss(toast) {
    clearTimeout(toast._timer);
    toast.classList.remove('toast--visible');
    toast.classList.add('toast--exit');
    toast.addEventListener('transitionend', function () { toast.remove(); });
    /* Fallback removal */
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 400);
  }

  window.showToast = showToast;
})();

/* ==========================================================================
   Collection Filters + Sort
   ========================================================================== */
(function () {
  var filterForm = document.querySelector('[data-filter-form]');
  var sortSelect = document.querySelector('[data-sort-select]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  var filterToggle = document.querySelector('[data-filter-toggle]');

  if (!filterForm && !sortSelect) return;

  /* --- Sort select: navigate on change --- */
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* --- Filter form: build URL from all inputs and navigate --- */
  if (filterForm) {
    var debounceTimer;
    filterForm.addEventListener('change', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyFilters, 500);
    });
  }

  function applyFilters() {
    if (!filterForm) return;
    var url = new URL(window.location.href);
    /* Clear existing filter params (keep sort_by) */
    var sortBy = url.searchParams.get('sort_by');
    url.search = '';
    if (sortBy) url.searchParams.set('sort_by', sortBy);

    var inputs = filterForm.querySelectorAll('[data-filter-input]');
    inputs.forEach(function (input) {
      if (input.type === 'checkbox' && input.checked) {
        url.searchParams.append(input.name, input.value);
      } else if (input.type === 'number' && input.value !== '') {
        url.searchParams.set(input.name, input.value);
      }
    });

    window.location.href = url.toString();
  }

  /* --- Mobile filter drawer toggle --- */
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filterPanel.classList.toggle('filter-panel--mobile-open');
      filterToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('filter-open', isOpen);
    });

    /* Close on overlay click */
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('filter-panel--mobile-open')) return;
      if (filterPanel.classList.contains('filter-panel--mobile-open')
          && !filterPanel.contains(e.target)
          && e.target !== filterToggle
          && !filterToggle.contains(e.target)) {
        filterPanel.classList.remove('filter-panel--mobile-open');
        filterToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('filter-open');
      }
    });
  }
})();

/* ==========================================================================
   Predictive Search
   ========================================================================== */
(function () {
  var searchContainers = document.querySelectorAll('[data-site-search], .mobile-menu__search');
  if (!searchContainers.length) return;

  searchContainers.forEach(function (container) {
    var input = container.querySelector('[data-search-input], .mobile-menu__search-input');
    if (!input) return;

    var resultsEl = document.createElement('div');
    resultsEl.className = 'predictive-search';
    resultsEl.setAttribute('role', 'listbox');
    resultsEl.setAttribute('aria-label', 'Search suggestions');
    input.parentElement.appendChild(resultsEl);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'predictive-search-results');

    var debounce;
    var cache = {};

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var query = input.value.trim();
      if (query.length < 2) { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); return; }

      debounce = setTimeout(function () { fetchResults(query); }, 300);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var first = resultsEl.querySelector('a');
        if (first) first.focus();
      }
    });

    /* Close on click outside */
    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); }
    });

    function fetchResults(query) {
      if (cache[query]) { render(cache[query]); return; }

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products : [];
          cache[query] = products;
          render(products);
        })
        .catch(function () { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); });
    }

    function escapeAttr(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function safeUrl(url) {
      url = String(url || '');
      return /^(https?:)?\//.test(url) ? url : '';
    }

    function render(products) {
      if (!products.length) {
        resultsEl.innerHTML = '<div class="predictive-search__empty">No results found</div>';
        resultsEl.classList.add('is-open');
        return;
      }

      var html = products.map(function (p) {
        var img = p.image ? '<img src="' + escapeAttr(safeUrl(p.image).replace(/(\.\w+)$/, '_120x$1')) + '" alt="" width="48" height="48" loading="lazy">' : '';
        var price = window.cartDrawer && typeof window.cartDrawer.formatMoney === 'function'
          ? window.cartDrawer.formatMoney(p.price)
          : '&pound;' + (parseInt(p.price, 10) / 100).toFixed(2);
        return '<a class="predictive-search__item" href="' + escapeAttr(safeUrl(p.url)) + '" role="option">'
          + '<div class="predictive-search__image">' + img + '</div>'
          + '<div class="predictive-search__info">'
          + '<span class="predictive-search__title">' + escapeAttr(p.title) + '</span>'
          + '<span class="predictive-search__price">' + price + '</span>'
          + '</div></a>';
      }).join('');

      html += '<a class="predictive-search__view-all" href="/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product">View all results &rarr;</a>';

      resultsEl.innerHTML = html;
      resultsEl.classList.add('is-open');

      /* Keyboard navigation within results */
      resultsEl.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); var next = a.nextElementSibling; if (next) next.focus(); }
          if (e.key === 'ArrowUp') { e.preventDefault(); var prev = a.previousElementSibling; if (prev) prev.focus(); else input.focus(); }
          if (e.key === 'Escape') { resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); input.focus(); }
        });
      });
    }
  });
})();

/* ==========================================================================
   Social Sharing — product page
   ========================================================================== */
(function () {
  var shareContainer = document.querySelector('[data-share-buttons]');
  if (!shareContainer) return;

  shareContainer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;

    var platform = btn.dataset.share;
    var url = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);
    var shareUrls = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + url,
      twitter: 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title,
      whatsapp: 'https://wa.me/?text=' + title + '%20' + url,
      email: 'mailto:?subject=' + title + '&body=' + url
    };

    if (platform === 'copy') {
      navigator.clipboard.writeText(window.location.href).then(function () {
        if (window.showToast) window.showToast('Link copied to clipboard!', { type: 'success' });
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.innerHTML = btn.dataset.originalHtml; }, 2000);
      });
      return;
    }

    if (shareUrls[platform]) {
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    }
  });
})();

/* ==========================================================================
   Cart Page — qty steppers, auto-update, line removal, note autosave
   ========================================================================== */
(function () {
  var section = document.querySelector('[data-cart-section]');
  if (!section) return;

  var form = section.querySelector('[data-cart-form]');
  var noteInput = section.querySelector('#cart-note');
  var checkoutBtn = section.querySelector('[data-cart-checkout-btn]');

  var moneyFormat = window.shopMoneyFormat || '\u00a3{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountNoDec = Math.round(cents / 100).toString();
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDec)
      .replace('{{amount_no_decimals}}', amountNoDec)
      .replace('{{amount}}', amount);
  }

  function setBusy(busy) {
    section.classList.toggle('is-cart-busy', !!busy);
    if (checkoutBtn) checkoutBtn.disabled = !!busy;
  }

  function refreshCart() {
    setBusy(true);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        // Update line item totals + qty inputs
        cart.items.forEach(function (item) {
          var row = section.querySelector('[data-cart-key="' + item.key + '"]');
          if (!row) return;
          var qtyInput = row.querySelector('[data-qty-input]');
          if (qtyInput) qtyInput.value = item.quantity;
          var lineTotal = row.querySelector('.cart-item__line-total');
          if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
        });

        // Remove rows for items no longer in cart
        var presentKeys = cart.items.map(function (i) { return i.key; });
        section.querySelectorAll('[data-cart-key]').forEach(function (row) {
          if (presentKeys.indexOf(row.dataset.cartKey) === -1) {
            row.classList.add('is-removing');
            setTimeout(function () { row.remove(); }, 200);
          }
        });

        // Update totals
        var subtotalEls = section.querySelectorAll('[data-cart-subtotal]');
        subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.items_subtotal_price); });
        var totalEls = section.querySelectorAll('[data-cart-total], [data-cart-total-cta], [data-cart-sticky-total]');
        totalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

        // Update cart count in heading
        var countEl = section.querySelector('.cart__count');
        if (countEl) {
          countEl.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';
        }

        // Update header badge if any
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });

        // Hide the "needs design" banner once no pending items remain in the DOM.
        var pBanner = section.querySelector('.cart-pending-banner');
        if (pBanner) {
          var stillPending = section.querySelectorAll('[data-design-pending]').length
            + section.querySelectorAll('.cart-item__pack-status--incomplete').length;
          if (stillPending === 0) pBanner.style.display = 'none';
        }
      })
      .catch(function (err) {
        console.error('Cart refresh error:', err);
        if (window.showToast) window.showToast('Could not update cart. Please refresh.', { type: 'error' });
      })
      .finally(function () { setBusy(false); });
  }

  function changeItem(key, quantity) {
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && (data.description || data.message) || 'Could not update item.');
          return data;
        });
      })
      .then(function () { return refreshCart(); })
      .catch(function (err) {
        console.error('Cart update error:', err);
        if (window.showToast) window.showToast(err && err.message ? err.message : 'Could not update item. Please try again.', { type: 'error' });
        return refreshCart();
      })
      .finally(function () { setBusy(false); });
  }

  function getProperty(properties, name) {
    if (!properties) return '';
    var value = properties[name];
    return value === null || value === undefined ? '' : String(value);
  }

  function setProperty(properties, name, value) {
    if (value === null || value === undefined || value === '') {
      delete properties[name];
      return;
    }
    properties[name] = String(value);
  }

  function closePackCopyMenus(exceptMenu) {
    section.querySelectorAll('[data-cart-pack-copy-menu]').forEach(function (menu) {
      if (menu === exceptMenu) return;
      menu.hidden = true;
      var toggle = menu.parentElement && menu.parentElement.querySelector('[data-cart-pack-copy-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function copyPackDesign(lineKey, sourceSlot, targetSpec, triggerBtn) {
    if (!lineKey || !sourceSlot || !targetSpec) return;

    var originalText = triggerBtn ? triggerBtn.textContent : '';
    if (triggerBtn) {
      triggerBtn.disabled = true;
      triggerBtn.textContent = 'Copying...';
    }
    setBusy(true);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not read cart');
        return r.json();
      })
      .then(function (cart) {
        var item = (cart.items || []).find(function (candidate) {
          return candidate && candidate.key === lineKey;
        });
        if (!item) throw new Error('Could not find this pack in the cart');

        var properties = Object.assign({}, item.properties || {});
        var packSize = parseInt(getProperty(properties, '_pack_size'), 10) || 0;
        if (packSize < 2) throw new Error('This item is not a pack');
        if (getProperty(properties, '_customization_suite').indexOf('bundle') > -1) {
          throw new Error('Bundle items need separate mug and coaster designs');
        }

        var sourcePreview = getProperty(properties, '_design_' + sourceSlot + '_preview_url');
        var sourceProduction = getProperty(properties, '_design_' + sourceSlot + '_production_url');
        var sourceDraft = getProperty(properties, '_design_' + sourceSlot + '_draft_key');
        if (!sourcePreview && !sourceProduction) {
          throw new Error('This source item does not have a design yet');
        }

        var targets = [];
        if (targetSpec === 'empty') {
          for (var i = 1; i <= packSize; i++) {
            if (i === sourceSlot) continue;
            var targetPreview = getProperty(properties, '_design_' + i + '_preview_url');
            var targetProduction = getProperty(properties, '_design_' + i + '_production_url');
            if (!targetPreview && !targetProduction) targets.push(i);
          }
        } else {
          var targetSlot = parseInt(targetSpec, 10);
          if (!isNaN(targetSlot) && targetSlot >= 1 && targetSlot <= packSize && targetSlot !== sourceSlot) {
            targets.push(targetSlot);
          }
        }

        if (!targets.length) throw new Error('There are no matching items to copy to');

        targets.forEach(function (targetSlot) {
          setProperty(properties, '_design_' + targetSlot + '_preview_url', sourcePreview);
          setProperty(properties, '_design_' + targetSlot + '_production_url', sourceProduction);
          setProperty(properties, '_design_' + targetSlot + '_draft_key', sourceDraft);
        });

        var filledSlots = 0;
        for (var s = 1; s <= packSize; s++) {
          if (getProperty(properties, '_design_' + s + '_preview_url')
            || getProperty(properties, '_design_' + s + '_production_url')) filledSlots++;
        }
        if (filledSlots >= packSize) delete properties._design_status;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: item.quantity, properties: properties })
        }).then(function (r) {
          if (!r.ok) throw new Error('Could not update the pack');
          return r.json();
        });
      })
      .then(function () {
        if (window.showToast) window.showToast('Design copied to selected item' + (targetSpec === 'empty' ? 's' : '') + '.', { type: 'success' });
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Pack design copy error:', err);
        if (window.showToast) window.showToast(err && err.message ? err.message : 'Could not copy design.', { type: 'error' });
      })
      .finally(function () {
        if (triggerBtn) {
          triggerBtn.disabled = false;
          triggerBtn.textContent = originalText;
        }
        setBusy(false);
      });
  }

  /* ----- Qty stepper buttons ----- */
  section.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-line-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    var copyToggle = e.target.closest('[data-cart-pack-copy-toggle]');
    var copyOption = e.target.closest('[data-cart-pack-copy-target]');

    if (copyToggle) {
      e.preventDefault();
      var menu = copyToggle.parentElement && copyToggle.parentElement.querySelector('[data-cart-pack-copy-menu]');
      if (!menu) return;
      var willOpen = menu.hidden;
      closePackCopyMenus(menu);
      menu.hidden = !willOpen;
      copyToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (copyOption) {
      e.preventDefault();
      var row = copyOption.closest('[data-cart-key]');
      var sourceSlot = parseInt(copyOption.dataset.cartPackCopySource, 10);
      var targetSpec = copyOption.dataset.cartPackCopyTarget;
      closePackCopyMenus();
      copyPackDesign(row && row.dataset.cartKey, sourceSlot, targetSpec, copyOption);
      return;
    }

    if (stepBtn) {
      e.preventDefault();
      var key = stepBtn.dataset.qtyLineChange;
      var dir = stepBtn.dataset.direction;
      var input = stepBtn.parentElement.querySelector('[data-qty-input]');
      var current = parseInt(input.value, 10) || 0;
      var next = dir === 'plus' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      changeItem(key, next);
    }

    if (removeBtn) {
      e.preventDefault();
      changeItem(removeBtn.dataset.cartRemove, 0);
    }
  });

  document.addEventListener('click', function (e) {
    if (section.contains(e.target) && e.target.closest('.cart-item__pack-copy')) return;
    closePackCopyMenus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePackCopyMenus();
  });

  /* ----- Direct number-input changes ----- */
  // One debounce timer per line key — a single shared timer would cancel
  // line A's pending update when line B changes within the window.
  var qtyDebounces = {};
  section.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var key = input.dataset.cartKey;
    var value = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = value;
    clearTimeout(qtyDebounces[key]);
    qtyDebounces[key] = setTimeout(function () {
      delete qtyDebounces[key];
      changeItem(key, value);
    }, 250);
  });

  /* ----- Auto-save the order note ----- */
  if (noteInput) {
    var noteDebounce = null;
    noteInput.addEventListener('input', function () {
      clearTimeout(noteDebounce);
      noteDebounce = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: noteInput.value })
        }).catch(function (err) { console.error('Note save error:', err); });
      }, 600);
    });
  }

  /* ----- Warn before checkout when items still need a design ----- */
  // Count live DOM markers so it stays accurate after AJAX removals/edits:
  // single pending lines carry [data-design-pending]; incomplete packs carry
  // .cart-item__pack-status--incomplete.
  function currentPendingCount() {
    var singles = section.querySelectorAll('[data-design-pending]').length;
    var packs = section.querySelectorAll('.cart-item__pack-status--incomplete').length;
    return singles + packs;
  }
  function confirmPendingCheckout() {
    var count = currentPendingCount();
    if (count < 1) return true;
    return window.confirm(
      (count === 1
        ? 'One item still needs a design.'
        : count + ' items still need a design.')
      + ' Continue to checkout anyway? We’ll email you to collect the artwork.'
    );
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!confirmPendingCheckout()) e.preventDefault();
    });
  }
  // Express buttons (Shop Pay, PayPal, GPay…) don't submit the cart form, so
  // they'd skip the warning above — guard their clicks in the capture phase.
  var expressWrap = section.querySelector('.cart-summary__express');
  if (expressWrap) {
    expressWrap.addEventListener('click', function (e) {
      if (!confirmPendingCheckout()) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }
})();

/* ==========================================================================
   Design Preview Lightbox — replaces the external R2 "Preview" link
   ========================================================================== */
(function () {
  var modal = document.querySelector('[data-cart-design-modal]');
  if (!modal) return;
  // Cart 3D lightbox. Deliberately NOT behind the app proxy: it is a heavy
  // three.js page in an iframe and the URL bar never shows it, so routing it
  // through Shopify's proxy would add a hop for no shopper-visible benefit.
  var PREVIEW_ORIGIN = 'https://123custom-shopify-app.vercel.app';
  var PREVIEW_PATH   = '/preview';

  var imageEl = modal.querySelector('[data-cart-design-image]');
  var imageWrapEl = modal.querySelector('[data-cart-design-image-wrap]');
  var iframeEl = modal.querySelector('[data-cart-design-iframe]');
  var loaderEl = modal.querySelector('[data-cart-design-loader]');
  var viewSwitchEl = modal.querySelector('[data-cart-design-view-switch]');
  var viewBtns = modal.querySelectorAll('[data-cart-design-view]');
  var mediaTitleEl = modal.querySelector('[data-cart-design-media-title]');
  var mediaHintEl = modal.querySelector('[data-cart-design-media-hint]');
  var titleEl = modal.querySelector('[data-cart-design-title]');
  var variantEl = modal.querySelector('[data-cart-design-variant]');
  var detailsEl = modal.querySelector('[data-cart-design-details]');
  var editEl = modal.querySelector('[data-cart-design-edit]');
  var closeEls = modal.querySelectorAll('[data-cart-design-close]');

  var lastFocus = null;
  var has3dPreview = false;
  var hasFlatPreview = false;
  var previewLoadToken = 0;
  var previewRevealTimer = null;
  var previewRevealDelayMs = 10000;

  function setLoaderVisible(visible) {
    if (!loaderEl) return;
    loaderEl.hidden = !visible;
  }

  function clearPreviewRevealTimer() {
    if (previewRevealTimer) {
      window.clearTimeout(previewRevealTimer);
      previewRevealTimer = null;
    }
  }

  function set3dLoading(loading) {
    setLoaderVisible(loading);
    if (iframeEl) {
      iframeEl.style.visibility = loading ? 'hidden' : 'visible';
      iframeEl.style.opacity = loading ? '0' : '1';
    }
  }

  function preloadArtwork(url, callback) {
    if (!url) {
      callback();
      return;
    }

    var image = new window.Image();
    image.crossOrigin = 'anonymous';

    function done() {
      image.onload = null;
      image.onerror = null;
      callback();
    }

    image.onload = done;
    image.onerror = done;
    image.src = url;

    if (image.complete) done();
  }

  function reveal3dPreview() {
    clearPreviewRevealTimer();
    if (!modal.classList.contains('is-open') || !has3dPreview) return;
    set3dLoading(false);
    setPreviewMode('3d');
  }

  function setPreviewMode(mode) {
    var nextMode = mode === '3d' && has3dPreview ? '3d' : 'flat';
    var show3dPlaceholder = nextMode === '3d' && hasFlatPreview && loaderEl && !loaderEl.hidden;

    viewBtns.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.cartDesignView === nextMode);
    });

    if (iframeEl) iframeEl.style.display = nextMode === '3d' ? 'block' : 'none';
    if (imageWrapEl) imageWrapEl.style.display = (nextMode === 'flat' && hasFlatPreview) || show3dPlaceholder ? 'flex' : 'none';

    if (mediaTitleEl) {
      mediaTitleEl.textContent = nextMode === '3d' ? '3D mug preview' : 'Flat print artwork';
    }
    if (mediaHintEl) {
      mediaHintEl.textContent = nextMode === '3d'
        ? (show3dPlaceholder ? 'Loading 3D preview...' : 'Spin the mug or switch to the flat artwork view.')
        : 'This is the non-3D print file saved for production.';
    }

    if (nextMode !== '3d') set3dLoading(false);
  }

  function is3dPreviewEligible(data) {
    var title = String(data && data.title || '').toLowerCase();
    var suite = String(data && data.suite || '').toLowerCase();
    var slot = String(data && data.slot || '').toLowerCase();
    // Mixed bundles: the line title may say "mug" while this slot is the
    // coaster — only trust the slot label in that case.
    if (slot && suite.indexOf('bundle') !== -1 && !/\bmug\b/.test(slot)) return false;
    var isMagicMug = /magic[\s-]?mug/.test(title) || suite === 'magic-mug';
    var isWhiteMug = !isMagicMug && (suite === 'mug' || /\bmug\b/.test(title));
    return isWhiteMug;
  }

  function openModal(data) {
    if (!data) return;
    lastFocus = document.activeElement;
    previewLoadToken += 1;
    clearPreviewRevealTimer();

    var productionUrl = data.productionUrl || data.production;
    var flatUrl = productionUrl || data.preview || '';
    has3dPreview = !!(productionUrl && iframeEl && is3dPreviewEligible(data));
    hasFlatPreview = !!(flatUrl && imageEl && imageWrapEl);
    set3dLoading(has3dPreview);

    if (iframeEl) {
      iframeEl.src = '';
      if (!has3dPreview) iframeEl.style.visibility = 'visible';
    }
    if (imageEl) {
      imageEl.src = flatUrl;
      imageEl.alt = data.title ? data.title + ' design preview' : 'Design preview';
    }
    if (viewSwitchEl) viewSwitchEl.hidden = !(has3dPreview && hasFlatPreview);
    setPreviewMode(has3dPreview ? '3d' : 'flat');

    if (titleEl) titleEl.textContent = data.title || '';
    if (variantEl) {
      if (data.variant && data.variant !== 'Default Title') {
        variantEl.textContent = data.variant;
        variantEl.style.display = '';
      } else {
        variantEl.textContent = '';
        variantEl.style.display = 'none';
      }
    }
    if (detailsEl) {
      detailsEl.innerHTML = data.detailsHtml || '';
      detailsEl.style.display = data.detailsHtml ? '' : 'none';
    }
    if (editEl) {
      if (data.reopen) {
        editEl.href = data.reopen;
        editEl.style.display = '';
      } else {
        editEl.removeAttribute('href');
        editEl.style.display = 'none';
      }
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-design-modal-open');

    if (has3dPreview && iframeEl) {
      var loadToken = previewLoadToken;
      var previewUrl = PREVIEW_ORIGIN + PREVIEW_PATH + '?artwork=' + encodeURIComponent(productionUrl);
      preloadArtwork(productionUrl, function () {
        if (loadToken !== previewLoadToken || !modal.classList.contains('is-open')) return;
        iframeEl.src = previewUrl;
      });
    }

    var focusTarget = modal.querySelector('.cart-design-modal__close');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeModal() {
    previewLoadToken += 1;
    clearPreviewRevealTimer();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-design-modal-open');
    if (imageEl) imageEl.src = '';
    if (iframeEl) {
      iframeEl.src = '';
      iframeEl.style.display = 'none';
      iframeEl.style.visibility = 'visible';
      iframeEl.style.opacity = '1';
    }
    set3dLoading(false);
    if (imageWrapEl) imageWrapEl.style.display = 'none';
    if (viewSwitchEl) viewSwitchEl.hidden = true;
    has3dPreview = false;
    hasFlatPreview = false;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
  window.addEventListener('message', function (event) {
    if (!modal.classList.contains('is-open') || !has3dPreview || !iframeEl) return;
    if (event.origin !== PREVIEW_ORIGIN) return;
    if (event.source !== iframeEl.contentWindow) return;
    if (!event.data || event.data.type !== 'custom-preview:ready') return;
    reveal3dPreview();
  });
  if (iframeEl) {
    iframeEl.addEventListener('load', function () {
      clearPreviewRevealTimer();
      previewRevealTimer = window.setTimeout(function () {
        reveal3dPreview();
      }, previewRevealDelayMs);
    });
  }
  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPreviewMode(btn.dataset.cartDesignView);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      e.preventDefault();
      closeModal();
    }
  });

  /* ---------- Open from cart page ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-design-preview-trigger]');
    if (!trigger) return;
    var card = trigger.closest('[data-design-card]');
    if (!card) return;
    e.preventDefault();

    var detailsHtml = '';
    var detailsEl = card.querySelector('[data-design-properties]');
    if (detailsEl) detailsHtml = detailsEl.innerHTML;

    openModal({
      preview: card.dataset.designPreview,
      productionUrl: card.dataset.designProduction,
      reopen: card.dataset.designReopen,
      title: card.dataset.designTitle,
      variant: card.dataset.designVariant,
      suite: card.dataset.designSuite,
      slot: card.dataset.designSlot,
      detailsHtml: detailsHtml
    });
  });

  /* ---------- Open from cart drawer (intercept old external Preview link) ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-design-preview-link]');
    if (!link) return;
    e.preventDefault();
    openModal({
      preview: link.dataset.preview,
      productionUrl: link.dataset.production,
      reopen: link.dataset.reopen,
      title: link.dataset.title,
      variant: link.dataset.variant,
      suite: link.dataset.suite,
      detailsHtml: link.dataset.detailsHtml || ''
    });
  });

  /* Public API for other scripts (e.g. cart drawer renderer) */
  window.cartDesignPreview = { open: openModal, close: closeModal };
})();

/* ==========================================================================
   Lazy-load videos — attach the real source only when near the viewport,
   so the homepage doesn't download multi-MB video on every visit
   ========================================================================== */
(function () {
  var videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  function attach(video) {
    var changed = false;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
      changed = true;
    });
    if (changed) {
      video.load();
      if (video.autoplay) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* user must click controls */ });
      }
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(attach);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      attach(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  videos.forEach(function (video) { observer.observe(video); });
})();
